var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 176,
    viewBox: "0 0 185 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.711 138.736L101.772 98.4224C98.2247 95.3121 97.8708 89.9124 100.989 86.3653L122.625 61.7013C125.735 58.1543 131.135 57.8003 134.682 60.9181L180.621 101.231C184.168 104.342 184.522 109.741 181.404 113.289L159.768 137.952C156.65 141.492 151.258 141.846 147.711 138.736Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.711 138.736L101.772 98.4224C98.2247 95.3121 97.8708 89.9124 100.989 86.3653L122.625 61.7013C125.735 58.1543 131.135 57.8003 134.682 60.9181L180.621 101.231C184.168 104.342 184.522 109.741 181.404 113.289L159.768 137.952C156.65 141.492 151.258 141.846 147.711 138.736Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.161 78.3225L132.572 81.3198L134.824 78.7517L131.412 75.762L129.206 78.2773C129.198 78.2924 129.183 78.3075 129.161 78.3225Z",
    fill: "#49A5B1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.931 73.3749C130.358 72.8703 129.485 72.9306 128.98 73.5029L126.713 76.086C126.209 76.6584 126.269 77.532 126.841 78.0366C127.414 78.5412 128.287 78.4809 128.792 77.9085L131.059 75.3254C131.563 74.753 131.503 73.8719 130.931 73.3749Z",
    fill: "#49A5B1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.495 73.1563C132.007 73.7588 132.097 74.6023 131.744 75.2951L135.2 78.3301L135.727 77.7276C136.285 77.0875 136.224 76.116 135.584 75.5587L132.082 72.4861L131.495 73.1563Z",
    fill: "#49A5B1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128.717 78.6764C128.099 79.0303 127.324 79.0153 126.706 78.6161L126.111 79.2939L125.69 78.9249L126.284 78.2471C125.81 77.6898 125.697 76.9216 125.968 76.2589L122.474 73.1938L122.045 73.6758C121.487 74.3159 121.547 75.2874 122.188 75.8447L129.613 82.359C130.253 82.9163 131.225 82.8561 131.782 82.2159L132.211 81.7339L128.717 78.6764Z",
    fill: "#49A5B1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.095 70.2041L122.844 72.7722L126.255 75.7695C126.27 75.7544 126.278 75.7318 126.293 75.7092L128.499 73.1939L125.095 70.2041Z",
    fill: "#49A5B1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M128.92 72.8173C129.56 72.3729 130.411 72.3579 131.074 72.7871L131.668 72.1094L128.167 69.0367C127.526 68.4794 126.555 68.5397 125.998 69.1798L125.47 69.7823L128.92 72.8173Z",
    fill: "#49A5B1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M146.679 127.989C149.258 127.989 151.349 125.898 151.349 123.319C151.349 120.741 149.258 118.65 146.679 118.65C144.101 118.65 142.01 120.741 142.01 123.319C142.01 125.898 144.101 127.989 146.679 127.989Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M145.79 127.04C145.685 125.812 146.054 124.547 146.935 123.546C147.793 122.567 148.976 122.032 150.181 121.964",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M151.875 122.174C152.47 122.363 153.035 122.679 153.532 123.116C155.475 124.818 155.664 127.77 153.962 129.705C152.26 131.648 149.307 131.837 147.372 130.135C146.875 129.698 146.498 129.186 146.235 128.628",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M136.678 103.679L141.505 107.919",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M113.874 83.6694L133.809 101.156",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M110.561 87.4421L127.054 101.917",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M113.551 118.733L113.897 118.665C113.973 118.65 113.988 118.65 113.988 118.65L116.044 118.243C116.872 118.078 117.565 118.899 117.241 119.682C116.488 121.519 114.741 124.449 110.787 126.844L65.812 135.038C65.812 135.038 52.2712 138.57 44.7478 126.399",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M113.143 118.816L74.1778 126.573C73.3946 126.731 72.6641 127.093 72.0767 127.627C60.607 138.171 51.5623 132.989 47.3299 129.171C46.0948 128.056 45.2664 127.055 44.9049 126.595C44.8447 126.505 44.7919 126.437 44.7543 126.392C44.7317 126.37 44.7242 126.347 44.7166 126.332C44.7091 126.324 44.7091 126.324 44.7016 126.317C38.8952 117.95 24.2851 90.9363 28.9317 35.6891C29.0974 33.6708 30.6413 32.0366 32.6445 31.7579L79.4947 25.2211C81.8293 24.8972 83.8852 26.7574 83.7949 29.107C83.1096 46.1948 82.4619 106.367 106.531 116.173C106.538 116.173 112.797 118.884 113.143 118.816Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M113.551 118.733L113.897 118.665C113.973 118.65 113.988 118.65 113.988 118.65L116.044 118.243C116.872 118.078 117.565 118.899 117.241 119.682C116.488 121.519 114.741 124.449 110.787 126.844L65.812 135.038C65.812 135.038 52.2712 138.57 44.7478 126.399",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5568 125.309L74.178 126.582C73.3948 126.74 72.6643 127.101 72.0769 127.636C60.6073 138.179 51.5626 132.998 47.3302 129.18C46.0951 128.065 45.2666 127.064 44.9052 126.604C44.8449 126.514 44.7922 126.446 44.7545 126.401C44.7319 126.378 44.7244 126.356 44.7169 126.341C44.7094 126.333 44.7093 126.333 44.7018 126.326C38.8954 117.959 24.2853 90.9451 28.932 35.6979C29.0976 33.6796 30.6415 32.0454 32.6448 31.7667L79.4949 25.2298C81.8295 24.906 83.8855 26.7662 83.7951 29.1158C83.6822 31.9098 83.5692 35.8485 83.5692 40.5328",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6526 47.4072C84.2099 72.0184 88.2088 108.709 106.539 116.173C106.539 116.173 112.805 118.884 113.144 118.816L86.921 124.035",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3992 39.7036L70.0287 36.7966",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8975 44.2671L70.527 41.3601",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9448 42.2791L72.9816 38.7847",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0239 65.3914L53.6798 62.7405",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2518 61.3623L78.4638 59.9841",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M68.891 67.8689L79.103 66.4907",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8396 74.4211L80.0516 73.043",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0754 80.6415L81.2874 79.2559",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M72.415 86.9602L82.627 85.582",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7935 93.2932L84.0055 91.915",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8147 111.94L92.0267 110.562",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9049 72.1841L50.8178 70.0303",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4312 78.9246L51.3441 76.7708",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9592 85.6644L56.6543 82.8704",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7655 92.337L53.6785 90.1831",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4546 98.814L56.3675 96.6602",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2708 117.205L63.1837 115.058",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M113.108 22.924C119.126 22.924 124.005 18.0451 124.005 12.0267C124.005 6.00829 119.126 1.12939 113.108 1.12939C107.089 1.12939 102.211 6.00829 102.211 12.0267C102.211 18.0451 107.089 22.924 113.108 22.924Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M117.648 21.938C116.315 22.548 114.847 22.902 113.288 22.9245C107.27 23.03 102.308 18.2327 102.21 12.2155C102.104 6.19825 106.901 1.23535 112.919 1.13745C118.936 1.03201 123.899 5.82924 123.997 11.8465",
    stroke: "#1F1927",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M113.025 17.2302L111.247 16.9139L111.473 15.6563C110.863 15.4605 110.298 15.1442 109.937 14.7676L109.666 14.489L110.622 12.8246L111.097 13.2765C111.458 13.6229 111.978 13.8865 112.482 13.9769C113.055 14.0823 113.469 13.879 113.544 13.4648C113.589 13.2012 113.567 12.8698 112.663 12.305C111.601 11.6498 110.547 10.7837 110.803 9.32273C111.006 8.19308 111.872 7.43245 113.055 7.29689L113.296 5.97144L115.058 6.28775L114.84 7.50776C115.322 7.66591 115.728 7.89185 116.082 8.20062L116.414 8.47926L115.435 10.1135L114.975 9.72941C114.802 9.57879 114.433 9.27754 113.763 9.15705C113.273 9.06667 112.949 9.21729 112.889 9.55619C112.844 9.81224 112.889 10.0306 113.913 10.6858C114.855 11.2808 115.909 12.177 115.623 13.766C115.412 14.9333 114.493 15.7391 113.266 15.8822L113.025 17.2302Z",
    fill: "#1F1927"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M104.695 13.3594C103.957 8.71278 107.127 4.35233 111.774 3.62183",
    stroke: "#1F1927",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3812 36.8795L81.3101 38.2201C80.3461 38.3029 79.5027 37.5875 79.4274 36.6235L79.111 32.8204C79.0282 31.8564 79.7436 31.0129 80.7076 30.9376L96.7787 29.5971C97.7427 29.5143 98.5861 30.2297 98.6614 31.1937L98.9777 34.9968C99.053 35.9532 98.3376 36.7967 97.3812 36.8795Z",
    fill: "#49A5B1"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3765 29.8003L97.0801 29.5743C97.8709 29.5066 98.5713 30.2521 98.6541 31.2387L98.9629 34.9514C99.0457 35.938 98.4734 36.789 97.6826 36.8568L80.9864 38.25C80.1957 38.3178 79.4953 37.5722 79.4125 36.5857L79.1037 32.8729C79.0208 31.8863 79.5932 31.0353 80.3839 30.9676L89.4211 30.2145",
    stroke: "#1F1927",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14645 101.781C4.01089 101.743 3.88284 101.698 3.74728 101.638C2.46702 101.066 1.88717 99.5594 2.46706 98.2791L9.80975 81.8541C10.3821 80.5738 11.8883 80.0014 13.1685 80.5738C14.4488 81.1462 15.0287 82.6523 14.4488 83.9326L7.10611 100.358C6.59401 101.51 5.32881 102.097 4.14645 101.781Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1019 102.79C14.6158 102.79 15.8431 101.562 15.8431 100.048C15.8431 98.5345 14.6158 97.3071 13.1019 97.3071C11.5879 97.3071 10.3606 98.5345 10.3606 100.048C10.3606 101.562 11.5879 102.79 13.1019 102.79Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74129 85.2127C5.25525 85.2127 6.48252 83.9854 6.48252 82.4715C6.48252 80.9575 5.25525 79.7302 3.74129 79.7302C2.22732 79.7302 1 80.9575 1 82.4715C1 83.9854 2.22732 85.2127 3.74129 85.2127Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1371 89.1139L7.10644 100.358C6.59434 101.51 5.3216 102.09 4.13924 101.781C4.00368 101.743 3.87568 101.698 3.74012 101.638C2.45985 101.066 1.87996 99.5594 2.45985 98.2791L9.80254 81.8541C10.3749 80.5738 11.8811 80.0014 13.1613 80.5738C14.4416 81.1462 15.0215 82.6523 14.4416 83.9326L13.5605 85.8982",
    stroke: "#1F1927",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1019 102.79C14.6158 102.79 15.8431 101.562 15.8431 100.048C15.8431 98.5345 14.6158 97.3071 13.1019 97.3071C11.5879 97.3071 10.3606 98.5345 10.3606 100.048C10.3606 101.562 11.5879 102.79 13.1019 102.79Z",
    stroke: "#1F1927",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74129 85.2127C5.25525 85.2127 6.48252 83.9854 6.48252 82.4715C6.48252 80.9575 5.25525 79.7302 3.74129 79.7302C2.22732 79.7302 1 80.9575 1 82.4715C1 83.9854 2.22732 85.2127 3.74129 85.2127Z",
    stroke: "#1F1927",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9039 127.04V161.72",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3445 151.395V171.729",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M136.678 135.512V175.351",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M151.348 147.93V165.093",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateSuccess);
export default __webpack_public_path__ + "static/media/create-success.a289f80689326d138227ee72494611ef.svg";
export { ForwardRef as ReactComponent };